import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch } from "hooks/redux"
import { Creators as DialogCreators } from "modules/dialog/model"

interface ResetAction {
  type: string
}

/**
 * The upload bars intercept the logo instead of navigating: leaving mid-upload discards the
 * scan, so the shell asks first and only then clears the module's state.
 */
export default function useCancelUploadPrompt(returnTo: string, resetUpload: () => ResetAction) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  return useCallback(() => {
    dispatch(DialogCreators.open({
      title: "Would you like to cancel this upload",
      contentText: "Canceling will clear all options and delete any data provided during this upload.",
      cancelText: "Return To Upload",
      buttons: [{
        text: "Cancel Upload",
        type: "primary",
        action: () => {
          navigate(returnTo, { replace: true })
          dispatch(resetUpload())
        },
      }],
    }))
  }, [dispatch, navigate, returnTo, resetUpload])
}
